export function scrollToHash(container = document) {
  let headerHeight = parseInt(getComputedStyle(document.querySelector('header')).height, 10);
  let anchors = container.querySelectorAll('a[href^="#"]');
  let anchorsLinks = container.querySelectorAll('a[href*="/#"]');
  for (let anchor of anchors) {
    const href = anchor.getAttribute('href');
    const target = href !== '#' && container.querySelector(href);
    if (!target) continue;
    const offset = headerHeight;
    anchor?.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: window.scrollY + target.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      })
    })
  }
  for (let anchorsLink of anchorsLinks) {
    const href = anchorsLink.getAttribute('href');
    const test = href.split('#')[1];
    const target = href !== '#' && container.querySelector('#' + test);
    if (!target) continue;
    const offset = headerHeight;
    anchorsLink?.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: window.scrollY + target.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      })
    })
  }
}
